import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { getModalPortal as x } from "../../../../../helpers/modal-helper.js";
import { AnimatePresence as v, m } from "motion/react";
import i from "./mobile-menu-modal.module.less.js";
import * as n from "@radix-ui/react-dialog";
import { VisuallyHidden as h } from "@radix-ui/react-visually-hidden";
const N = ({
  children: s,
  isOpen: a,
  portalContainer: r,
  close: c,
  anchor: e = "bottom",
  title: d
}) => {
  const y = typeof c?.function == "function" ? c.function : void 0, p = r || x(), o = 0.265, u = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: o, type: "tween", ease: "easeInOut" }
  }, f = e === "bottom" ? {
    initial: { y: "100%" },
    animate: { y: 0 },
    exit: { y: "100%" },
    transition: { duration: o, type: "tween", ease: "easeInOut" }
  } : {
    initial: { x: "100%" },
    animate: { x: 0 },
    exit: { x: "100%" },
    transition: { duration: o, type: "tween", ease: "easeInOut" }
  };
  return /* @__PURE__ */ t(v, { children: a && /* @__PURE__ */ t(n.Root, { open: a, modal: !0, children: /* @__PURE__ */ l(n.Portal, { container: p, children: [
    /* @__PURE__ */ t(m.div, { ...u, children: /* @__PURE__ */ t(n.Overlay, { className: [i.modalOverlay].join(" ") }) }),
    /* @__PURE__ */ l(n.Content, { onEscapeKeyDown: y, className: [i.content, i[e]].join(" "), children: [
      /* @__PURE__ */ t(h, { children: /* @__PURE__ */ t(n.Title, { children: d }) }),
      /* @__PURE__ */ t(m.div, { ...f, children: /* @__PURE__ */ t("div", { className: i.innerContent, children: s }) })
    ] })
  ] }) }) }, e);
};
export {
  N as MobileMenuModal,
  N as default
};
